//
// Copyright 2021 DXOS.org
//
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_any, file_google_protobuf_empty, file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_dxos_config } from "../config_pb.js";
import { file_dxos_devtools_swarm } from "../devtools/swarm_pb.js";
import { file_dxos_echo_timeframe } from "../echo/timeframe_pb.js";
import { file_dxos_error } from "../error_pb.js";
import { file_dxos_halo_credentials } from "../halo/credentials_pb.js";
import { file_dxos_keys } from "../keys_pb.js";
import { file_dxos_mesh_signal } from "../mesh/signal_pb.js";
import { file_dxos_mesh_presence } from "../mesh/presence_pb.js";
import { file_dxos_mesh_teleport_gossip } from "../mesh/teleport/gossip_pb.js";
/**
 * Describes the file dxos/client/invitation.proto.
 */
export const file_dxos_client_invitation = /*@__PURE__*/ fileDesc("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", [file_google_protobuf_any, file_google_protobuf_empty, file_google_protobuf_struct, file_google_protobuf_timestamp, file_dxos_config, file_dxos_devtools_swarm, file_dxos_echo_timeframe, file_dxos_error, file_dxos_halo_credentials, file_dxos_keys, file_dxos_mesh_signal, file_dxos_mesh_presence, file_dxos_mesh_teleport_gossip]);
/**
 * Describes the message dxos.client.services.AdmissionKeypair.
 * Use `create(AdmissionKeypairSchema)` to create a new message.
 */
export const AdmissionKeypairSchema = /*@__PURE__*/ messageDesc(file_dxos_client_invitation, 0);
/**
 * Describes the message dxos.client.services.Invitation.
 * Use `create(InvitationSchema)` to create a new message.
 */
export const InvitationSchema = /*@__PURE__*/ messageDesc(file_dxos_client_invitation, 1);
/**
 * @generated from enum dxos.client.services.Invitation.Type
 */
export var Invitation_Type;
(function (Invitation_Type) {
    /**
     * / Requires both to be online to complete key exchange.
     *
     * @generated from enum value: INTERACTIVE = 0;
     */
    Invitation_Type[Invitation_Type["INTERACTIVE"] = 0] = "INTERACTIVE";
    /**
     * / Invitation can be accepted by any valid peer.
     *
     * @generated from enum value: DELEGATED = 1;
     */
    Invitation_Type[Invitation_Type["DELEGATED"] = 1] = "DELEGATED";
    /**
     * *
     * Multi-use interactive invitations.
     * @deprecated use multiUse flag with type=interactive instead.
     *
     * @generated from enum value: MULTIUSE = 2;
     */
    Invitation_Type[Invitation_Type["MULTIUSE"] = 2] = "MULTIUSE";
})(Invitation_Type || (Invitation_Type = {}));
/**
 * Describes the enum dxos.client.services.Invitation.Type.
 */
export const Invitation_TypeSchema = /*@__PURE__*/ enumDesc(file_dxos_client_invitation, 1, 0);
/**
 * @generated from enum dxos.client.services.Invitation.Kind
 */
export var Invitation_Kind;
(function (Invitation_Kind) {
    /**
     * / Unset / unknown. Must not be used for new invitations.
     *
     * @generated from enum value: INVALID = 0;
     */
    Invitation_Kind[Invitation_Kind["INVALID"] = 0] = "INVALID";
    /**
     * @generated from enum value: DEVICE = 1;
     */
    Invitation_Kind[Invitation_Kind["DEVICE"] = 1] = "DEVICE";
    /**
     * @generated from enum value: SPACE = 2;
     */
    Invitation_Kind[Invitation_Kind["SPACE"] = 2] = "SPACE";
})(Invitation_Kind || (Invitation_Kind = {}));
/**
 * Describes the enum dxos.client.services.Invitation.Kind.
 */
export const Invitation_KindSchema = /*@__PURE__*/ enumDesc(file_dxos_client_invitation, 1, 1);
/**
 * @generated from enum dxos.client.services.Invitation.AuthMethod
 */
export var Invitation_AuthMethod;
(function (Invitation_AuthMethod) {
    /**
     * / No authentication is required. Guest should not call `Authenticate`.
     *
     * @generated from enum value: NONE = 0;
     */
    Invitation_AuthMethod[Invitation_AuthMethod["NONE"] = 0] = "NONE";
    /**
     * / Guest should call `Authenticate` with the shared secret.
     *
     * @generated from enum value: SHARED_SECRET = 1;
     */
    Invitation_AuthMethod[Invitation_AuthMethod["SHARED_SECRET"] = 1] = "SHARED_SECRET";
    /**
     * / Guest should prove they possess a private key corresponding to the known public key recorded in an invitation.
     *
     * @generated from enum value: KNOWN_PUBLIC_KEY = 2;
     */
    Invitation_AuthMethod[Invitation_AuthMethod["KNOWN_PUBLIC_KEY"] = 2] = "KNOWN_PUBLIC_KEY";
})(Invitation_AuthMethod || (Invitation_AuthMethod = {}));
/**
 * Describes the enum dxos.client.services.Invitation.AuthMethod.
 */
export const Invitation_AuthMethodSchema = /*@__PURE__*/ enumDesc(file_dxos_client_invitation, 1, 2);
/**
 * @generated from enum dxos.client.services.Invitation.State
 */
export var Invitation_State;
(function (Invitation_State) {
    /**
     * @generated from enum value: INIT = 0;
     */
    Invitation_State[Invitation_State["INIT"] = 0] = "INIT";
    /**
     * @generated from enum value: CONNECTING = 1;
     */
    Invitation_State[Invitation_State["CONNECTING"] = 1] = "CONNECTING";
    /**
     * @generated from enum value: CONNECTED = 2;
     */
    Invitation_State[Invitation_State["CONNECTED"] = 2] = "CONNECTED";
    /**
     * @generated from enum value: READY_FOR_AUTHENTICATION = 3;
     */
    Invitation_State[Invitation_State["READY_FOR_AUTHENTICATION"] = 3] = "READY_FOR_AUTHENTICATION";
    /**
     * @generated from enum value: AUTHENTICATING = 4;
     */
    Invitation_State[Invitation_State["AUTHENTICATING"] = 4] = "AUTHENTICATING";
    /**
     * @generated from enum value: SUCCESS = 5;
     */
    Invitation_State[Invitation_State["SUCCESS"] = 5] = "SUCCESS";
    /**
     * @generated from enum value: CANCELLED = 6;
     */
    Invitation_State[Invitation_State["CANCELLED"] = 6] = "CANCELLED";
    /**
     * @generated from enum value: TIMEOUT = 7;
     */
    Invitation_State[Invitation_State["TIMEOUT"] = 7] = "TIMEOUT";
    /**
     * @generated from enum value: ERROR = 8;
     */
    Invitation_State[Invitation_State["ERROR"] = 8] = "ERROR";
    /**
     * @generated from enum value: EXPIRED = 9;
     */
    Invitation_State[Invitation_State["EXPIRED"] = 9] = "EXPIRED";
})(Invitation_State || (Invitation_State = {}));
/**
 * Describes the enum dxos.client.services.Invitation.State.
 */
export const Invitation_StateSchema = /*@__PURE__*/ enumDesc(file_dxos_client_invitation, 1, 3);
/**
 * / Runtime state of the space object.
 *
 * @generated from enum dxos.client.services.SpaceState
 */
export var SpaceState;
(function (SpaceState) {
    /**
     * @generated from enum value: INVALID = 0;
     */
    SpaceState[SpaceState["INVALID"] = 0] = "INVALID";
    /**
     * / Space is inactive. No swarming or replication will be done.
     *
     * @generated from enum value: SPACE_INACTIVE = 2;
     */
    SpaceState[SpaceState["SPACE_INACTIVE"] = 2] = "SPACE_INACTIVE";
    /**
     * / Space is active. Swarming and replication will be done.
     *
     * @generated from enum value: SPACE_ACTIVE = 6;
     */
    SpaceState[SpaceState["SPACE_ACTIVE"] = 6] = "SPACE_ACTIVE";
    /**
     * / Space is tombstoned (soft-deleted). Replicated to other devices; never auto-opened.
     *
     * @generated from enum value: SPACE_DELETED = 9;
     */
    SpaceState[SpaceState["SPACE_DELETED"] = 9] = "SPACE_DELETED";
    /**
     * / Space is closed.
     *
     * @generated from enum value: SPACE_CLOSED = 1;
     */
    SpaceState[SpaceState["SPACE_CLOSED"] = 1] = "SPACE_CLOSED";
    /**
     * / Data pipeline is inactive.
     *
     * @generated from enum value: SPACE_CONTROL_ONLY = 7;
     */
    SpaceState[SpaceState["SPACE_CONTROL_ONLY"] = 7] = "SPACE_CONTROL_ONLY";
    /**
     * / Data pipeline is initializing.
     *
     * @generated from enum value: SPACE_INITIALIZING = 4;
     */
    SpaceState[SpaceState["SPACE_INITIALIZING"] = 4] = "SPACE_INITIALIZING";
    /**
     * / Data pipeline is ready.
     *
     * @generated from enum value: SPACE_READY = 3;
     */
    SpaceState[SpaceState["SPACE_READY"] = 3] = "SPACE_READY";
    /**
     * / Space errored.
     *
     * @generated from enum value: SPACE_ERROR = 5;
     */
    SpaceState[SpaceState["SPACE_ERROR"] = 5] = "SPACE_ERROR";
    /**
     * / Data migration is required.
     *
     * @generated from enum value: SPACE_REQUIRES_MIGRATION = 8;
     */
    SpaceState[SpaceState["SPACE_REQUIRES_MIGRATION"] = 8] = "SPACE_REQUIRES_MIGRATION";
})(SpaceState || (SpaceState = {}));
/**
 * Describes the enum dxos.client.services.SpaceState.
 */
export const SpaceStateSchema = /*@__PURE__*/ enumDesc(file_dxos_client_invitation, 0);
//# sourceMappingURL=invitation_pb.js.map